<template>
  <a-tabs v-model:activeKey="activeKey" @tabClick="tabClick">
    <a-tab-pane key="1" tab="APP广告列表" :disabled="loading">
      <app-ads-list
        :dateTime="dateTime"
        :is-refresh="isRefresh"
        :activeKey="activeKey"
      ></app-ads-list>
    </a-tab-pane>
    <a-tab-pane key="2" tab="APP广告配置" :disabled="loading">
      <app-ads-config
        @switchTab="handleSwitchTab"
        :is-refresh="isRefresh"
      ></app-ads-config>
    </a-tab-pane>
    <a-tab-pane key="3" tab="广告源" :disabled="loading">
      <ads-source :is-refresh="isRefresh"></ads-source>
    </a-tab-pane>
  </a-tabs>
</template>
<script setup lang="ts">
import { ref, computed, watch } from "vue";
import AppAdsList from "./components/AppAdsList.vue";
import AppAdsConfig from "./components/AppAdsConfig.vue";
import AdsSource from "./components/AdsSource.vue";
import dayjs from "dayjs";

const activeKey = ref("1");
const loading = ref(false);
const accountId = ref("");
let dateValue: (string | number | Date | dayjs.Dayjs | null | undefined)[] = [];

const props = defineProps(["dateTime", "isRefresh"]);

watch(() => props.dateTime, (newVal) => {
  //console.log(newVal);
  dateValue = newVal;
});

const tabClick = (key: string) => {
  activeKey.value = key;
};

const handleSwitchTab = (id: string) => {
  activeKey.value = "1";
  accountId.value = id;
};
</script>
